import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3af844a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Signing out...", -1))
const _hoisted_2 = [
  _hoisted_1
]

import { onMounted } from 'vue'
import { reloadApp, usePageTitle } from '@/util/AppUtil'
import { useTokenManager } from "@/auth/TokenManager"
import { AsyncUtil } from '@/util/AsyncUtil'


export default /*#__PURE__*/_defineComponent({
  __name: 'SignOutPage',
  setup(__props) {

usePageTitle("Signing out")

const tokenManager = useTokenManager()

onMounted(async () => {
    await AsyncUtil.delay(500) // show message
    tokenManager.clearCurrentToken();
    reloadApp("/")
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, _hoisted_2))
}
}

})